import { takeLatest, all, call, put } from 'redux-saga/effects';
import { setLoading, removeLoading, parseJwt } from '../../utils';
import { post, get, put as putCall, del } from '../../api';
import {
  ADD_EXPENSES,
  VIEW_EXPENSES_SUCCESS,
  VIEW_EXPENSES,
  POST_UID,
  DELETE_EXPENSES,
  UPDATE_EXPENSES,
} from '../constants';
import { VIEW_EXPENSES as VIEW_EXPENSES_ROUTE } from '../../constants';

import {
  EXPENSES as EXPENSES_API,
  VIEW_EXPENSES as VIEW_EXPENSES_API,
  UPDATE_UID,
} from '../../api/endpoints';

function* addExpenses({ payload }) {
  setLoading();
  const baseApi = `${EXPENSES_API}`;
  yield call(post, {
    endpoint: baseApi,
    params: payload,
  });
  window.location.href = `${VIEW_EXPENSES_ROUTE}`;
  removeLoading();
}

function* viewExpenses({ payload }) {
  const { salon_id, month, year } = payload;

  setLoading();
  const baseApi = `${VIEW_EXPENSES_API}${salon_id}/expenses?month=${month}&year=${year}`;
  const {
    data: { expenses },
  } = yield call(get, baseApi);
  yield put({ type: VIEW_EXPENSES_SUCCESS, data: expenses });
  removeLoading();
}

function* updateExpense({ payload: { expense, expenseId } }) {
  const baseApi = `${EXPENSES_API}/${expenseId}`;
  setLoading();
  yield call(putCall, {
    endpoint: baseApi,
    params: expense,
  });
  window.location.href = `${VIEW_EXPENSES_ROUTE}`;
  removeLoading();
}

function* deleteExpenses({ payload }) {
  setLoading();
  const baseApi = `${EXPENSES_API}/${payload}`;
  yield call(del, baseApi);
  window.location.href = `${VIEW_EXPENSES_ROUTE}`;
  removeLoading();
}

function* postUid({ payload }) {
  const { user_id } = parseJwt() || {};
  if (user_id) {
    const baseApi = `${UPDATE_UID}${user_id}/uid`;
    setLoading();
    yield call(putCall, {
      endpoint: baseApi,
      params: payload,
    });
    removeLoading();
  }
}

function* actionWatcher() {
  yield takeLatest(ADD_EXPENSES, addExpenses);
  yield takeLatest(VIEW_EXPENSES, viewExpenses);
  yield takeLatest(POST_UID, postUid);
  yield takeLatest(DELETE_EXPENSES, deleteExpenses);
  yield takeLatest(UPDATE_EXPENSES, updateExpense);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
